import { render, staticRenderFns } from "./SAccContent.vue?vue&type=template&id=2932f4a9&scoped=true"
import script from "./SAccContent.vue?vue&type=script&lang=ts"
export * from "./SAccContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2932f4a9",
  null
  
)

export default component.exports